export const initState = {
	title: '',
	date: '',
	content: '',
	image: '',
	_status: 'init',
};

export default initState;
